<div class="layoutBlock">
  <div class="columnHalf">
    <p-accordion [multiple]="true" [value]="['0']">
        <p-accordion-panel value="0">
            <p-accordion-header>{{uiText.FILTER_TITLE_DATE | hisUi}}</p-accordion-header>
            <p-accordion-content>
                 <div class="communicationDateContainer">
                     <his-plam class="noPlamButtonContainer">
                         <p-calendar #content
                             [hisDdKey]="uiText.FILTER_SETTING_FROM"
                             [showIcon]="true"
                             [dateFormat]="uiText.DATE_FORMAT | hisUi"
                             styleClass="calendarWidth40"
                             [monthNavigator]="true"
                             [yearNavigator]="true"
                             placeholder="TT.MM.JJJJ"
                             [maxDate]="filterSettings.to"
                             [(ngModel)]="filterSettings.from"
                             (ngModelChange)="emitFilterSettingsChanged()"
                             appendTo="body">
                         </p-calendar>
                     </his-plam>
                     <his-plam styleClass="noPlamButtonContainer">
                          <p-calendar #content
                          [hisDdKey]="uiText.FILTER_SETTING_TO"
                          [showIcon]="true"
                          [dateFormat]="uiText.DATE_FORMAT | hisUi"
                          styleClass="calendarWidth40"
                          [monthNavigator]="true"
                          [yearNavigator]="true"
                          placeholder="TT.MM.JJJJ"
                          [minDate]="filterSettings.from"
                          [(ngModel)]="filterSettings.to"
                          (ngModelChange)="emitFilterSettingsChanged()"
                          appendTo="body">
                          </p-calendar>
                     </his-plam>
                 </div>
            </p-accordion-content>
         </p-accordion-panel>
         <p-accordion-panel value="1">
             <p-accordion-header>{{uiText.FILTER_TITLE_OTHER | hisUi}}</p-accordion-header>
             <p-accordion-content>
             <div class="communicationFilterContainer">
             @for (filter of filters; track filter) {
                 <his-plam>
                     <input type="checkbox" #content
                         [hisDdKey]="filter.key"
                         [(ngModel)]="filter.value"
                         (ngModelChange)="emitFilterSettingsChanged()">
                 </his-plam>
              }
              @if (this.renderOwnerActivityFilter) {
              <his-plam>
                  <input type="checkbox" #content
                      [hisDdKey]="uiText.FILTER_SETTING_OWNER_ACTIVITY"
                      [(ngModel)]="filterSettings.ownerActivity"
                      (ngModelChange)="emitFilterSettingsChanged()">
               </his-plam>
           }
          <his-plam>
            <input type="checkbox" #content
              [hisDdKey]="uiText.FILTER_SETTING_OWN_ACTIVITY"
              [(ngModel)]="filterSettings.ownActivity"
              (ngModelChange)="emitFilterSettingsChanged()">
          </his-plam>
          <his-plam>
            <input type="checkbox" #content
              [hisDdKey]="uiText.FILTER_SETTING_UNIVERSITY_ACTIVITY"
              [(ngModel)]="filterSettings.universityActivity"
              (ngModelChange)="emitFilterSettingsChanged()">
          </his-plam>
          <div class="clearer"></div>
          @if (availableDomains?.length > 1) {
            <div class="clearerSpaceAboveHalfEm"></div>
            <div class="layoutBlock">
              <div class="columnThreeQuarter">
                <his-multiselect-plam
                  [label]="uiText.COMMUNICATION_LOG_ENTRY_DOMAINS | hisUi"
                  [customOptionsMethod]="customDomainOptions.bind(this)"
                  [removeSelectedOptionsFromDropdown]="true"
                  [(selectedOptions)]="domainSelection"
                  (selectedOptionsChange)="emitFilterSettingsChanged()">
                </his-multiselect-plam>
                <div class="clearerSpaceAboveHalfEm"></div>
              </div>
            </div>
          }
        </div>
            </p-accordion-content>
        </p-accordion-panel>
    </p-accordion>
  </div>
</div>
<div class="clearer">